__turbopack_context__.v({
  "container": "RichTextContent-module__6tArzW__container",
});
